import { useForm } from "react-hook-form";
import Breadcrumbs from "../components/breadcrumbs";
import Header from "../components/header";
import { useAddTicket } from "../hooks/useQueryCart";
import { usePage } from "../hooks/useQueryCustom";
import PageContent from "../components/page-content";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigazione } from "../context/navigazione";

const RegistraBiglietti = ({ page, breadcrumbs }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({
    defaultValues: {
      barcode: null,
    },
  });
  const { getPathByTemplate } = useNavigazione();
  const { data } = usePage(page.link.slice(1));
  const linkBigliettiScuola = getPathByTemplate("registraBigliettiScuola");
  const [step, setStep] = useState(false);
  const addTicket = useAddTicket();
  console.log("errors", errors);
  const onSubmit = async (data) => {
    try {
      console.log("payload", data);
      const response = await addTicket.mutateAsync(data);
      console.log("response", response);
    } catch (err) {
      if (err?.code === "T22") {
        setStep(true);
      }
      setError("root.serverError", {
        type: err?.code,
      });
      console.error("Error: ", err?.code);
    }
  };

  return (
    <>
      <Header data={breadcrumbs} />
      {breadcrumbs && <Breadcrumbs data={breadcrumbs} />}
      <div role="main" className="main-wrapper  mt-3" id="main">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <h1>{data?.titoloInPagina}</h1>
            </div>
          </div>
          <div className="bg-gray px-4 py-5 mb-4">
            <div className="row">
              <div className="col-12 col-md-8 offset-md-2">
                <PageContent data={data} />

                <form
                  className="form"
                  name="premium"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <fieldset>
                    <label className="form__label  mb-2">
                      <strong>Barcode</strong>
                    </label>
                    <input
                      type="hidden"
                      value="barcode"
                      {...register("tipo")}
                    />
                    <input
                      className="form__input"
                      type="text"
                      readOnly={step}
                      minLength="13"
                      maxLength="13"
                      {...register("codice", {
                        required: true,
                        pattern: /^[0-9]{13}$/,
                      })}
                    />
                    {step && (
                      <div>
                        <p className="my-3">
                          <strong>
                            Inserisci nome e cognome dell'intestatario del
                            biglietto. Questi dati veranno utlizzati anche per
                            le relative prenotazioni
                          </strong>
                        </p>
                        <label className="form__label  mb-2">
                          <strong>Nome</strong>
                        </label>
                        <input
                          className="form__input"
                          type="text"
                          {...register("nome", {
                            required: true,
                          })}
                        />
                        <label className="form__label  mt-3 mb-2">
                          <strong>Cognome</strong>
                        </label>
                        <input
                          className="form__input"
                          type="text"
                          {...register("cognome", {
                            required: true,
                          })}
                        />
                        <label className="form__label my-3">
                          <strong>Privacy*</strong>
                          <br />
                          <input
                            type="checkbox"
                            className="form__checkbox"
                            {...register("privacy", {
                              required: "Consenso privacy mancante",
                            })}
                          />
                          Dichiaro di aver letto la{" "}
                          <Link
                            to="/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </Link>{" "}
                          del sito.
                        </label>
                      </div>
                    )}
                    {errors.codice?.type === "required" && (
                      <p role="alert" className="red my-2">
                        Bar code mancante
                      </p>
                    )}
                    {errors.codice?.type === "pattern" && (
                      <p role="alert" className="red my-2">
                        Bar code non valido
                      </p>
                    )}
                    {errors.privacy?.type === "required" && (
                      <p role="alert" className="red my-2">
                        {errors.privacy.message}
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T8" && (
                      <p role="alert" className="red my-2">
                        Bar code non valido o non verificabile
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T9" && (
                      <p role="alert" className="red my-2">
                        Bar code già utilizzato
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T10" && (
                      <p role="alert" className="red my-2">
                        Bar code già utilizzato
                      </p>
                    )}
                    {(errors?.root?.serverError?.type === "T11" ||
                      errors?.root?.serverError?.type === "T12") && (
                      <p role="alert" className="red my-2">
                        Servizio non disponoibile
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T17" && (
                      <p role="alert" className="red my-2">
                        Bar code di una pratica scuola. Per attivare i biglietti
                        scuola vai a{" "}
                        <Link
                          style={{ textDecoration: "underline" }}
                          to={linkBigliettiScuola}
                        >
                          questa pagina
                        </Link>
                      </p>
                    )}
                    {isSubmitSuccessful && (
                      <p className="red my-2">
                        Codice validato con successo. Per scoprire come
                        prenotare,{" "}
                        <Link
                          style={{ textDecoration: "underline" }}
                          to="/come-prenotare"
                        >
                          clicca qui
                        </Link>
                      </p>
                    )}
                    <button
                      className="btn btn--link mt-5 m-auto"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}{" "}
                      Invia
                    </button>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RegistraBiglietti;
